/* eslint-disable no-param-reassign,consistent-return */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { message, Modal } from "antd";
import rtkRequestStatusCodes from "../../lib/const/rtkRequestStatusCodes";
import {
  getBillById,
  getBillsByAggIdRoute,
  getBillsRoute,
  postBillPrepaymentRoute,
  postBillRoute,
  postBillLastPeriodRoute,
  postBillPeriodRoute,
  getBillsMassRoute,
  createPostBillPeriodRoute,
} from "../../lib/routes/bills";
import { getTaskActionsRoute } from "../../lib/routes/tasks-manager";
import Message from "../../components/Message/Message";
import { getRoute } from "../../lib/routes";
import { getDictionaryItemById } from "../../lib/utils";
import { store } from "../..";

const initialState = {
  accBillId: null,
  billInfo: "",
  bills: [],
  billInfoLoading: rtkRequestStatusCodes.idle,
  billsLoading: rtkRequestStatusCodes.idle,
  extendedSearchBillsLoading: rtkRequestStatusCodes.idle,
  bulkDeleteBillsLoading: rtkRequestStatusCodes.idle,
  bulkNotifyBillsLoading: rtkRequestStatusCodes.idle,
  bulkHardNotifyBillsLoading: rtkRequestStatusCodes.idle,
  addingBillsState: rtkRequestStatusCodes.idle,
  bulkSendBillsLoading: rtkRequestStatusCodes.idle,
  addBillLoading: rtkRequestStatusCodes.idle,
  postBillLoading: rtkRequestStatusCodes.idle,
  postBillPeriodCreateLoading: rtkRequestStatusCodes.idle,
  finExportSendLoading: rtkRequestStatusCodes.idle,
};

const createPostBill = createAsyncThunk("bills/createPostbill", async ({ bodyRequestArr }) => {
  // console.log(bodyRequestArr);
  // const response = await Promise.all(
  message.loading("Создание счетов...", 0);
  return Promise.all(
    bodyRequestArr.map(
      (postBill) => axios.post(createPostBillPeriodRoute(postBill))
      // {
      // const { route, string } = createPostBillPeriodRoute(postBill);
      // return axios.post(route, string);
      // return axios.post(createPostBillPeriodRoute(postBill));
      // })
    )
  )
    .then(() => {
      message.destroy();
      message.success("Счета созданы");
    })
    .catch(() => {
      message.destroy();
      message.error({ content: "Ошибка создания счетов" });
    });
  // const result = response.map(({ data }) => data);
  // console.log("result", result);
  // return null;
});

const fetchBillById = createAsyncThunk("bills/fetchBillById", async ({ billId }) => {
  try {
    const url = getBillById(billId);
    const { data } = await axios(url);
    return data;
  } catch (e) {
    Message("Ошибка загрузки данных. Попробуйте позже", e);
  }
});

const fetchBillsByAggId = createAsyncThunk("bills/fetchBillsByAggId", async ({ aggId = 0 }) => {
  try {
    let dataServices = [];
    await Promise.all(
      aggId.map(async (agg) => {
        const response = axios.get(getBillsByAggIdRoute(agg));
        const { data } = await response;
        if (response.length !== 0) {
          dataServices = [...dataServices, ...data];
        }
      })
    );
    return dataServices;
  } catch (e) {
    Message("Ошибка загрузки данных. Попробуйте позже", e);
  }
});

const extendedSearchBills = createAsyncThunk("bills/extendedSearchBills", async (searchParams) => {
  try {
    const { data } = await axios(getBillsMassRoute(searchParams));
    return data;
  } catch (e) {
    Message("Ошибка загрузки данных. Попробуйте позже", e);
  }
});

const bulkDeleteBills = createAsyncThunk("bills/bulkDeleteBills", async ({ bills, initiator }) => {
  const url = getTaskActionsRoute();
  const task = {
    type: "bill-removal",
    context: {
      initiator,
    },
    subTasksContext: bills,
  };
  message.loading("Создание заявки на удаление счета...", 0);
  try {
    await axios.post(url, task);
    message.destroy();
    message.success("Заявка создана");
  } catch (e) {
    message.destroy();
    Modal.error({
      content: e.response?.message || e || "Что-то пошло не так",
    });
  }
});

const bulkNotifyBills = createAsyncThunk("bills/bulkNotifyBills", async ({ bills, initiator }) => {
  const url = getTaskActionsRoute();
  const task = {
    type: "bill-notification",
    context: {
      type: "soft_notify",
      initiator,
    },
    subTasksContext: bills,
  };
  message.loading("Создание заявки на напоминание об оплате...", 0);
  try {
    await axios.post(url, task);
    message.destroy();
    message.success("Заявка создана");
  } catch (e) {
    message.destroy();
    Modal.error({
      content: e.response?.message || e || "Что-то пошло не так",
    });
  }
});

const bulkHardNotifyBills = createAsyncThunk(
  "bills/bulkHardNotifyBills",
  async ({ bills, initiator }) => {
    const url = getTaskActionsRoute();
    const task = {
      type: "bill-notification",
      context: {
        type: "hard_notify",
        initiator,
      },
      subTasksContext: bills,
    };
    message.loading("Создание заявки на напоминание об оплате...", 0);
    try {
      await axios.post(url, task);
      message.destroy();
      message.success("Заявка создана");
    } catch (e) {
      message.destroy();
      Modal.error({
        content: e.response?.message || e || "Что-то пошло не так",
      });
    }
  }
);

const bulkSendBills = createAsyncThunk(
  "bills/bulkSendBills",
  async ({ bills, initiator, reportId, formatType }) => {
    const url = getTaskActionsRoute();
    const task = {
      type: "bill-notification",
      context: {
        type: "send",
        initiator,
        reportId,
        formatType,
      },
      subTasksContext: bills,
    };
    message.loading("Создание заявки на отправку счетов...", 0);
    try {
      await axios.post(url, task);
      message.destroy();
      message.success("Заявка создана");
    } catch (e) {
      message.destroy();
      Modal.error({
        content: e.response.data.message || "Что-то пошло не так",
      });
      throw new Error();
    }
  }
);

const addBill = createAsyncThunk("bills/addBill", async (bill, { rejectWithValue }) => {
  const url = getBillsRoute();
  message.loading("Добавление счета...", 0);
  console.log("bill", bill);
  try {
    await axios.post(url, bill);
    message.destroy();
    const successMessage = bill.sendBill ? "Счета добавлены и отправлены" : "Счета добавлены";
    message.success(successMessage);
  } catch (e) {
    message.destroy();
    Modal.error({
      content: e.response.data.message || "Что-то пошло не так...",
    });
    throw new Error(e);
  }
});

const postBill = createAsyncThunk("bills/postBill", async (dataPost) => {
  try {
    message.loading("Добавление счета...", 0);
    const response = axios.post(postBillRoute(), dataPost);
    const { data } = await response;
    message.destroy();
    const successMessage = dataPost.sendBill
      ? "Счёт успешно добавлен и отправлены"
      : "Счёт добавлен";
    message.success(successMessage);
    return data;
  } catch (e) {
    message.destroy();
    Modal.error({
      content: e.response.data.message || "Что-то пошло не так...",
    });
    throw new Error(e);
  }
});

const postBillPrepayment = createAsyncThunk("bills/postBillPrepayment", async ({ date }) => {
  const url = postBillPrepaymentRoute(date);
  message.loading("Выставление счетов на предоплату...", 0);
  try {
    await axios.post(url);
    message.destroy();
    message.success("Задание сформировано");
  } catch (e) {
    message.destroy();
    Modal.error({
      content: e.response.data.message || "Ошибка выставления",
    });
    throw new Error();
  }
});

const postBillLastPeriodCreate = createAsyncThunk(
  "bills/postBillLastPeriodCreate",
  // eslint-disable-next-line consistent-return
  async (date) => {
    message.loading("Создание счетов...", 0);
    try {
      const response = axios.post(postBillLastPeriodRoute(date));
      const { data } = await response;
      const { status } = await response;
      message.destroy();
      Message("Счета созданы", status);
      return data;
    } catch (e) {
      message.destroy();
      Message("Ошибка создания счетов", e.response?.data?.message);
    }
  }
);

const postBillPeriodCreate = createAsyncThunk(
  "bills/postBillPeriodCreate",
  // eslint-disable-next-line consistent-return
  async (date) => {
    message.loading("Создание счетов...", 0);
    try {
      const response = axios.post(postBillPeriodRoute(date));
      const { data } = await response;
      const { status } = await response;
      message.destroy();
      Message("Счета созданы", status);
      return data;
    } catch (e) {
      message.destroy();
      Message("Ошибка создания счетов", e.response?.data?.message);
    }
  }
);

const deleteBills = createAsyncThunk(
  "bills/deleteBills",
  ({ agreementId, periodFrom, periodTo, useCoveringVariant }) => {
    const url = getRoute("billing-api", "bills");
    axios
      .delete(url, {
        data: {
          agreementId,
          periodFrom,
          periodTo,
          useCoveringVariant,
        },
      })
      .then(() => {
        Modal.success({
          title: "Задание завершено успешно",
        });
      })
      .catch(() => {
        Modal.error({
          title: "Ошибка удаления счетов",
        });
      });
  }
);

const finExportSend = createAsyncThunk(
  "bills/finExportSend",
  async ({ glsTypeId, periodFrom, periodTo }) => {
    const { glsTypes } = store.getState().rtkDictionaries;
    const url = getTaskActionsRoute();
    const task = {
      type: "fin-export",
      context: {
        glsTypeId,
        periodFrom,
        periodTo,
      },
    };

    message.loading("Создание задания...", 0);
    try {
      const response = await axios.post(url, task);
      message.destroy();
      message.success(`Создано задание ${response.data.id} на выполнение Процедуры выгрузки с типом ${getDictionaryItemById(glsTypes, glsTypeId)?.name}`);
      return response;
    } catch (e) {
      message.destroy();
      Modal.error({
        content: e.response.data.message || "Что-то пошло не так",
      });
      throw new Error();
    }
  }
);

export const billsSlice = createSlice({
  name: "bills",
  initialState,
  reducers: {
    setAccBillId: {
      reducer: (state, action) => {
        state.accBillId = localStorage.setItem(
          "accBillId",
          JSON.stringify(action.payload.accBillId)
        );
      },
    },
    clearBills: {
      reducer: (state) => {
        state.bills = [];
        state.billsLoading = rtkRequestStatusCodes.idle;
      },
    },
  },
  extraReducers: {
    [fetchBillById.fulfilled]: (state, action) => {
      state.billInfo = action.payload;
      state.billInfoLoading = rtkRequestStatusCodes.fulfilled;
    },
    [fetchBillById.pending]: (state) => {
      state.billInfoLoading = rtkRequestStatusCodes.pending;
    },
    [fetchBillsByAggId.fulfilled]: (state, action) => {
      state.bills = action.payload;
      state.billsLoading = rtkRequestStatusCodes.fulfilled;
    },
    [fetchBillsByAggId.pending]: (state) => {
      state.billsLoading = rtkRequestStatusCodes.pending;
    },
    [extendedSearchBills.fulfilled]: (state, { payload }) => {
      state.bills = payload;
      state.billsLoading = rtkRequestStatusCodes.fulfilled;
      state.extendedSearchBillsLoading = rtkRequestStatusCodes.fulfilled;
    },
    [extendedSearchBills.pending]: (state) => {
      state.billsLoading = rtkRequestStatusCodes.pending;
      state.extendedSearchBillsLoading = rtkRequestStatusCodes.pending;
    },
    [bulkDeleteBills.pending]: (state) => {
      state.bulkDeleteBillsLoading = rtkRequestStatusCodes.pending;
    },
    [bulkDeleteBills.fulfilled]: (state) => {
      state.bulkDeleteBillsLoading = rtkRequestStatusCodes.fulfilled;
    },
    [bulkNotifyBills.pending]: (state) => {
      state.bulkNotifyBillsLoading = rtkRequestStatusCodes.pending;
    },
    [bulkNotifyBills.fulfilled]: (state) => {
      state.bulkNotifyBillsLoading = rtkRequestStatusCodes.fulfilled;
    },
    [bulkHardNotifyBills.pending]: (state) => {
      state.bulkHardNotifyBillsLoading = rtkRequestStatusCodes.pending;
    },
    [bulkHardNotifyBills.fulfilled]: (state) => {
      state.bulkHardNotifyBillsLoading = rtkRequestStatusCodes.fulfilled;
    },
    [bulkHardNotifyBills.rejected]: (state) => {
      state.bulkHardNotifyBillsLoading = rtkRequestStatusCodes.rejected;
    },
    [bulkSendBills.pending]: (state) => {
      state.bulkSendBillsLoading = rtkRequestStatusCodes.pending;
    },
    [bulkSendBills.fulfilled]: (state) => {
      state.bulkSendBillsLoading = rtkRequestStatusCodes.fulfilled;
    },
    [bulkSendBills.rejected]: (state) => {
      state.bulkSendBillsLoading = rtkRequestStatusCodes.rejected;
    },
    [addBill.pending]: (state) => {
      state.addBillLoading = rtkRequestStatusCodes.pending;
    },
    [addBill.fulfilled]: (state) => {
      state.addBillLoading = rtkRequestStatusCodes.fulfilled;
    },
    [addBill.rejected]: (state) => {
      state.addBillLoading = rtkRequestStatusCodes.rejected;
    },
    [postBill.pending]: (state) => {
      state.postBillLoading = rtkRequestStatusCodes.pending;
    },
    [postBill.fulfilled]: (state) => {
      state.postBillLoading = rtkRequestStatusCodes.fulfilled;
    },
    [postBill.rejected]: (state) => {
      state.postBillLoading = rtkRequestStatusCodes.rejected;
    },
    [postBillPeriodCreate.pending]: (state) => {
      state.postBillPeriodCreateLoading = rtkRequestStatusCodes.pending;
    },
    [postBillPeriodCreate.fulfilled]: (state) => {
      state.postBillPeriodCreateLoading = rtkRequestStatusCodes.fulfilled;
    },
    [postBillPeriodCreate.rejected]: (state) => {
      state.postBillPeriodCreateLoading = rtkRequestStatusCodes.rejected;
    },
    [finExportSend.pending]: (state) => {
      state.finExportSendLoading = rtkRequestStatusCodes.pending;
    },
    [finExportSend.fulfilled]: (state) => {
      state.finExportSendLoading = rtkRequestStatusCodes.fulfilled;
    },
    [finExportSend.rejected]: (state) => {
      state.finExportSendLoading = rtkRequestStatusCodes.rejected;
    },
  },
});

const { reducer, actions } = billsSlice;

const { setAccBillId, clearBills } = actions;

export {
  clearBills,
  fetchBillById,
  fetchBillsByAggId,
  postBillPrepayment,
  extendedSearchBills,
  bulkDeleteBills,
  bulkNotifyBills,
  bulkHardNotifyBills,
  bulkSendBills,
  setAccBillId,
  addBill,
  postBill,
  postBillLastPeriodCreate,
  postBillPeriodCreate,
  createPostBill,
  deleteBills,
  finExportSend,
  reducer,
};
